import React, { useEffect, useState } from 'react';
import { TabContent, TabPane, Nav, NavItem, NavLink, Row, Col, Card, CardText } from 'reactstrap';
import { Link } from 'react-router-dom';
import ComponentCard from '../../../components/ComponentCard';

const GujraatStateHead = () => {
     const [activeTab, setActiveTab] = useState('1');
      const [data, setData] = useState([]);
      const [loading, setLoading] = useState(true);
      const [error, setError] = useState(null);
      const [searchTerm, setSearchTerm] = useState('');
    
      const user = JSON.parse(localStorage.getItem('user'));
    
      const fetchTabData = async (tab) => {
        const zone = user?.id;
        console.log(user,"user vid")
        setLoading(true);
        setError(null);
        let api = `https://amaapi.outdoorooh.com/api/gujaratcampaign-site-asm-project/${zone}`;
    
        if (tab === '2') {
          api = `https://amaapi.outdoorooh.com/api/gujaratcampaign-site-asm-approved-project/${zone}`;
        } else if (tab === '3') {
          api = `https://amaapi.outdoorooh.com/api/gujaratcampaign-site-asm-pending-project/${zone}`;
        } else if (tab === '4') {
          api = `https://amaapi.outdoorooh.com/api/gujaratcampaign-site-asm-rejected-project/${zone}`;
        }
    
        try {
          const response = await fetch(api);
          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }
          const result = await response.json();
          setData(result.data);
        } catch (err) {
          setError(err.message);
        } finally {
          setLoading(false);
        }
      };
    
      const toggle = (tab) => {
        if (activeTab !== tab) {
          setActiveTab(tab);
          fetchTabData(tab);
        }
      };
    
      useEffect(() => {
        fetchTabData(activeTab);
      }, []);
    
      if (loading) return <p>Loading...</p>;
      if (error) return <p>Error: {error}</p>;
    
      // Filter data based on search term
      const filteredData = data.filter((item) => {
        const term = searchTerm.toLowerCase();
        return (
          item.site_name?.toLowerCase().includes(term) ||
          item.code?.toLowerCase().includes(term)||
             item.state?.toLowerCase().includes(term)||
          item.zone?.toLowerCase().includes(term)
        );
      });
    
 return (
    <>
      {/* Search input */}
     <div className="d-flex justify-content-end mb-3">
  <input
    type="text"
    className="form-control p-2"
    placeholder="Search here"
    style={{ maxWidth: '300px' }}
    value={searchTerm}
    onChange={(e) => setSearchTerm(e.target.value)}
  />
</div>

      <ComponentCard title="Airtel Team Projects">
        {/* Tabs */}
        <Nav tabs>
          <NavItem>
            <NavLink className={activeTab === '1' ? 'active' : ''} onClick={() => toggle('1')}>
              All
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink className={activeTab === '2' ? 'active' : ''} onClick={() => toggle('2')}>
              Approved
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink className={activeTab === '3' ? 'active' : ''} onClick={() => toggle('3')}>
              Pending
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink className={activeTab === '4' ? 'active' : ''} onClick={() => toggle('4')}>
              Rejected
            </NavLink>
          </NavItem>
        </Nav>

        {/* Tabs Content */}
        <TabContent className="p-4" activeTab={activeTab}>
          <TabPane tabId={activeTab}>
            <Row>
              {filteredData.map((item) => (
                <Col md="6" lg="4" key={item.id}>
                  <Card body className="p-0 md:p-5">
                    {/* Carousel */}
                    <div id={`carousel-${item.id}`} className="carousel slide" data-bs-touch="false">
                      <Link
                        to={
                          activeTab === '3'
                            ? `/airtel-gujarat-statehead-pending/${item.id}`
                            : `/airtel-gujarat-state-head-detail/${item.id}`
                        }
                        style={{ color: '#333', textDecoration: 'none', marginTop: '10px' }}
                      >
                        <div className="carousel-inner">
                          {[item.image, item.image1, item.image2, item.image3, item.image4]
                            .filter((img) => img)
                            .map((img, index) => (
                              <div
                                className={`carousel-item ${index === 0 ? 'active' : ''}`}
                              >
                                <img
                                  src={`https://amaapi.outdoorooh.com/${img}`}
                                  loading="lazy"
                                  className="d-block w-100"
                                  style={{ height: '200px' }}
                                  alt={item.site_name}
                                />
                              </div>
                            ))}
                        </div>
                      </Link>

                      {/* Controls */}
                      {[item.image, item.image1, item.image2, item.image3, item.image4].filter(
                        (img) => img
                      ).length > 1 && (
                        <>
                          <button
                            className="carousel-control-prev"
                            type="button"
                            data-bs-target={`#carousel-${item.id}`}
                            data-bs-slide="prev"
                          >
                            <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                            <span className="visually-hidden">Previous</span>
                          </button>
                          <button
                            className="carousel-control-next"
                            type="button"
                            data-bs-target={`#carousel-${item.id}`}
                            data-bs-slide="next"
                          >
                            <span className="carousel-control-next-icon" aria-hidden="true"></span>
                            <span className="visually-hidden">Next</span>
                          </button>
                        </>
                      )}
                    </div>

                    {/* Site details */}
                    <Link
                      to={
                        activeTab === '3'
                          ? `/airtel-gujarat-statehead-pending/${item.id}`
                          : `/airtel-gujarat-state-head-detail/${item.id}`
                      }
                      style={{ color: '#333', textDecoration: 'none', marginTop: '10px' }}
                    >
                      <CardText>{item.code}</CardText>
                      <CardText>{item.site_name}</CardText>
                    </Link>
                  </Card>
                </Col>
              ))}
            </Row>
          </TabPane>
        </TabContent>
      </ComponentCard>
    </>
  );
}

export default GujraatStateHead